import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {Tag} from '@/components/ui/tag'
import {KairosMark} from '@/components/kairos-mark'

export function EncabezadoDeLaCola({
  sujeto,
  onVolver,
  onAbrirMapa,
}: {
  sujeto: string
  /** La pantalla decide si pregunta antes: sabe cuántas decisiones van en vuelo. */
  onVolver: () => void
  onAbrirMapa: () => void
}) {
  const {t} = useTranslation()
  return (
    <div>
      <button
        type="button"
        data-testid="cola-volver"
        className="font-mono text-[11px] text-primary hover:underline"
        onClick={onVolver}>
        {t('admin.bateria.cola.volver')}
      </button>
      <div className="mt-2 flex flex-wrap items-center gap-2 text-foreground">
        <KairosMark />
        <h1 className="font-heading text-xl">{t('admin.bateria.cola.titulo')}</h1>
        <Tag tone="neutral" data-testid="cola-sujeto">
          {sujeto}
        </Tag>
        <Button size="xs" variant="ghost" className="ml-auto" data-testid="cola-abrir-mapa" onClick={onAbrirMapa}>
          {t('admin.bateria.cola.mapa.abrir')}
        </Button>
      </div>
    </div>
  )
}
